import { component } from 'picoapp';
import Modal from 'utils/components/modal';

export default component((node) => {
  const modalElement = Modal(node);
  const open = document.querySelector('[data-category-modal-open]');
  const close = node.querySelector('[data-category-modal-close]');

  open.addEventListener('click', () => {
    modalElement.open();
  });

  close.addEventListener('click', () => {
    modalElement.close();
  });
});
